export enum PlanType {
    Starter,
    Business,
    Enterprise,
    Trial,
    ThirdParty,
    EnterpriseTrial,
    Core,
    Pro
}